import React from 'react';

import LogoSection from './LogoSection';
import Navbar from './Navbar';
import SocialMedia from './SocialMedia';

const Header = () => {
  return (
      <header className="header">
       <div className="d-flex justify-content-between align-items-center px-3 py-2 secondary">
        <LogoSection />
        <SocialMedia />
      </div>
     
      <Navbar />
    </header>
  );
};

export default Header;
